<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-14 16:50:34
 * @LastEditors: WUFAN
 * @LastEditTime: 2019-12-31
-->
<template>
  <el-form class="login-form"
          status-icon
          :rules="loginRules"
          ref="loginForm"
          :model="loginForm"
          label-width="0">
    <el-form-item prop="username">
      <el-input size="small"
                @keyup.enter.native="handleLogin"
                v-model="loginForm.username"
                autocomplete="off"
                placeholder="请输入账号">
        <i slot="prefix"   class="icon-yonghu"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input size="small"
                @keyup.enter.native="handleLogin"
                show-password
                type="password"
                autocomplete="off"
                auto-complete="new-password"
                v-model="loginForm.password"
                placeholder="请输入密码">
        <i slot="prefix"   class="icon-mima"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="code" v-if="code.haveCode">
      <el-row :span="24">
        <el-col :span="16">
          <el-input size="small"
                    @keyup.enter.native="handleLogin"
                    :maxlength="code.len"
                    v-model="loginForm.code"
                    auto-complete="off"
                    placeholder="请输入验证码">
            <i slot="prefix" class="icon-yanzhengma"></i>
          </el-input>
        </el-col>
        <el-col :span="8" >
          <div class="login-code">
            <img  :src="code.src" class="login-code-img" @click="getCode" />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
                size="small"
                @click.native.prevent="handleLogin"
                :loading="submitLoading"
                class="login-submit">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchlocalWebSetting } from '@/framework/util/util'
import { API_CONFIG } from '@/page/config/base_config'
// import rsa from '@/framework/util/crypto'
export default {
  name: 'Userlogin',
  data() {
    return {
      loginForm: {
        username: 'wipadmin',
        password: '111111',
        code: '1111'
      },
      'submitLoading': false,
      code: {
        len: 4,
        src: '',
        haveCode: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度最少为6位', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '验证码长度为4位', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  //   this.getCode()
  },
  computed: mapGetters(['website']),
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const {
            username,
            password,
            code
          } = this.loginForm
          const publicKey = this.website.publicKey
          publicKey.setOptions({ encryptionScheme: 'pkcs1' })
          const encryptedPW = publicKey.encrypt(password, 'base64')
          this.submitLoading = true
          this.$http.post('/system/login', {}, { 'params': {
            username,
            'password': API_CONFIG.PASS_RSA ? encryptedPW : password,
            'captcha': code
          }}).then(response => {
            /** 放入缓存 */
            this.$store.dispatch('Login', { loginInfo: response.data.loginInfo })
            /** 跳转到主页 */

            this.$store.dispatch('GetAllMenu').then(response => {
              /** 路由注册 */
              this.submitLoading = false
              fetchlocalWebSetting()
              let toUrl = this.$route.query.toUrl
              if (toUrl) {
                this.$router.push(toUrl)
              } else {
                let indexUrl = this.website.firstPage.value
                this.$router.push(indexUrl)
              }
            }).catch(e => {
              this.submitLoading = false
              this.$message.error('菜单获取失败')
            })
          }).catch(error => {
            this.submitLoading = false
            // 5 账号未找到	展示返回的错误描述
            // 6 状态异常	展示返回的错误描述
            // 7 密码错误	展示返回的错误描述
            // 19 密码错误且下次需要输入验证码	展示返回的错误描述并调用验证码生成接口,展示验证码
            // 1003 验证码未生成或已过期	调用验证码生成接口并展示验证码
            // 1004 验证码错误	展示返回的错误描述,并重新调用验证码生成接口,展示验证码
            if ([5, 6, 7, 22].includes(error.code)) {
              this.$message.error(error.msg)
            } else if ([19, 1003, 1004].includes(error.code)) {
              this.$message.error(error.msg)
              this.getCode()
            } else {
              this.$message.error('服务器返回标识无法解析,请联系系统管理员。')
            }
          })
        }
      })
    },
    getCode: function() {
      this.code.haveCode = true
      this.$downloadFile.get('/system/login-captcha', { params: {
        doDownload: false
      }}).then(response => {
        this.code.src = response.data.url
      }).catch(error => {
        this.$message.error('验证码获取失败,' + error.msg)
      })
    }
  }
}
</script>

